export const sessionsRoutes = [
  {
    path: '/create-account',
    name: 'CreateAccount',
    component: () =>
      import(/* webpackChunkName: "sessions" */ '../views/CreateAccount.vue')
  },
  {
    path: '/create-account/success',
    name: 'CreateAccountSuccess',
    props: { action: 'set' },
    component: () =>
      import(/* webpackChunkName: "sessions" */ '../views/CheckEmailCard.vue')
  },
  {
    path: '/login',
    name: 'Login',
    component: () =>
      import(/* webpackChunkName: "sessions" */ '../views/Login.vue')
  },
  {
    path: '/forgot-password',
    name: 'ForgotPassword',
    component: () =>
      import(/* webpackChunkName: "sessions" */ '../views/ForgotPassword.vue')
  },
  {
    path: '/forgot-password/success',
    name: 'ForgotPasswordSuccess',
    props: { action: 'reset' },
    component: () =>
      import(/* webpackChunkName: "sessions" */ '../views/CheckEmailCard.vue')
  },
  {
    path: '/set-password/token/:token',
    name: 'SetPassword',
    component: () =>
      import(/* webpackChunkName: "sessions" */ '../views/SetPassword.vue')
  },
  {
    path: '/session-expired',
    name: 'SessionExpired',
    component: () =>
      import(/* webpackChunkName: "sessions" */ '../views/SessionExpired.vue')
  }
]
